<template>
  <div class="qrcode" @click="goLink">
    <img src="@/assets/img-qrcode.png" alt="" />
  </div>
</template>

<script>
export default {
  name: "Qrcode",
  methods: {
    goLink() {
      window.open(
        "https://mp.weixin.qq.com/s/FtDFG6vQryCdWso7PMFIxA",
        "_blank"
      );
    },
  },
};
</script>

<style scoped lang="less">
.qrcode {
  position: fixed;
  right: 40px;
  bottom: 40px;
  z-index: 9999;
}
</style>